// Utility function to calculate text width in pixels
const getTextWidth = (text, font = 'arial') => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.font = `20px ${font}`; // Google uses ~20px font for titles
  return context.measureText(text).width;
};

export const getTitlePixelLength = (text) => {
  return getTextWidth(text);
};

export const getMetaPixelLength = (text) => {
  return getTextWidth(text);
};

export const TITLE_PIXEL_LIMITS = {
  min: 250,
  max: 580
};

export const META_PIXEL_LIMITS = {
  max: 900
}; 